module.exports = __webpack_public_path__ + "bd4dffd1d6a1e3d6393073caff4bec16.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/WaveMobile.mp4
// module id = 227
// module chunks = 0